import { createStore } from 'vuex'
import global from './modules/global'
import upload from './modules/upload'
import shopBindingModel from './modules/shopBindingModel'
import app from './modules/app'
import noticeListModel from './modules/noticeListModel'

export default createStore({
    modules: {
		global : global,
		upload : upload,
		shopBindingModel: shopBindingModel,
		app: app,
		noticeListModel: noticeListModel
	},
})
